import React, {Component} from 'react';
import axios from 'axios';
import {FaDatabase} from "react-icons/fa";
import { connect } from 'react-redux';
import {Alert} from 'reactstrap';
import { Spinner } from 'react-bootstrap';
import { Card, CardBody, Row } from 'reactstrap';
import BreadcrumbCustomer from "../../Layout/user/BreadcrumbCustomer";

class OrderHostingComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loadPage: true,
            isLoading: true,
            product: [],
            error: false,
            messageError: '',
            errorForm: false,
            messageErrorForm: '',
            isNotification: '',
            textNotification: '',
            isModal: false,
            titleModal: '',
            modalBody: '',
            groupUserId: 0,
            action: '',
            isSpinner: false,
            special: true,
            actionKey: 0,
            listOs: [],
            listAddon: { error: 1 },
            configBilling: {
                'monthly' : '1 Tháng',
                'twomonthly' : '2 Tháng',
                'quarterly' : '3 Tháng',
                'semi_annually' : '6 Tháng',
                'annually' : '1 Năm',
                'biennially' : '2 Năm',
                'triennially' : '3 Năm',
                'one_time_pay' : 'Vĩnh viễn',
                'free' : 'Miễn phí',
            },
            os: 0,
            billingCycle: this.props.billcycle,
            listBillingCycle: [],
            qtt: 1,
            addonCpu: 0,
            addonRam: 0,
            addonDisk: 0,
            btnSubmit: true,
            domain: ''
        }
    }

    componentDidMount() {
        document.querySelector('.cr-sidebar').classList.add('cr-sidebar--open');
        window.scrollTo(0, 0);
        // console.log(this.props.productId, this.props.billcycle)
        this.getProductById(this.props.productId, this.props.billcycle);
        this.loadPricing();
        this.setState({
            isNotification: this.props.isNotification,
            textNotification: this.props.textNotification,
        })
        if (this.props.isNotification) {
            this.props.notification({
                isNotification: false,
                textNotification: ''
            });
        }
    }

    getProductById = (productId, billcycle) => {
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        let data = '?productId=' + productId + '&billingCycle=' + billcycle;

        axios.get( process.env.REACT_APP_API_URL + '/api/product/getProduct' + data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if (ref.data.error === 0) {
                    this.setState({
                        product: ref.data.product,
                        special: ref.data.special,
                        listBillingCycle: ref.data.listBillingCycle,
                        billingCycle: this.state.billingCycle ? this.state.billingCycle : ref.data.listBillingCycle[0].value,
                        btnSubmit: false,
                        loadPage: false,
                        isLoading: false,
                    })
                } else {
                    if (ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            loadPage: false,
                            isLoading: false,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    loadPage: false,
                    isLoading: false,
                    error: true,
                    messageError: 'Lấy dữ liệu sản phẩm thất bại',
                })
            })
    }

    addCommas = (nStr) => {
        nStr += '';
        let x = nStr.split('.');
        let x1 = x[0];
        let x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            // eslint-disable-next-line no-useless-concat
            x1 = x1.replace(rgx, '$1' + '.' + '$2');
        }
        return x1 + x2;
    }

    loadConfig  = () => {
        if ( Object.keys(this.state.product).length ) {
            return (
                <>
                    Storage: { this.state.product.product_detail.storage } <br/>
                    Số lượng Domain: { this.state.product.product_detail.domain } Domain<br/>
                    Số lượng Alias Domain: { this.state.product.product_detail.alias_domain } Alias Domain<br/>
                    FTP: { this.state.product.product_detail.ftp } tài khoản FTP<br/>
                    Database: { this.state.product.product_detail.database } Database<br/>
                    Panel: { this.state.product.product_detail.panel } <br/>
                </>
            )
        }
    }

    changeInput = async (event) => {
        let name = event.target.name;
        let value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        await this.setState({
            [name]: value
        });
        if ( name === 'billingCycle' || name === 'qtt' ) {
            await this.loadPricing();
        }
    }

    loadPricing = () => {
        if ( Object.keys(this.state.product).length ) {
            // console.log(this.state.listAddon.addonCpu)
            let product = this.state.product;
            let pricing = product.product_pricing[ this.state.billingCycle ];
            let pricingAddonRam = 0;
            let pricingAddonCpu = 0;
            let pricingAddonDisk = 0;
            product.pricingProduct = pricing;
            // sub total
            product.sub_total = pricing + pricingAddonCpu + pricingAddonRam + pricingAddonDisk;
            this.setState({
                product: product
            })
        }
    }

    submit = () => {
        this.setState({
            btnSubmit: true,
        })
        if ( this.validate() ) {
            this.setState({
                loadPage: true,
            })
            let dataAuth = {
                username: process.env.REACT_APP_CLIENT_ID,
                password: process.env.REACT_APP_CLIENT_PASSWD,
                token: process.env.REACT_APP_KEY,
            };
            let form = {
                productId: this.props.productId,
                billingCycle: this.state.billingCycle,
                qtt: this.state.qtt,
                domain: this.state.domain,
            };
            axios.post( process.env.REACT_APP_API_URL + '/api/order/createOrderHosting', form,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization' : this.props.token,
                        'dataAgency' : JSON.stringify(dataAuth)
                    }
                }
            )
                .then( (ref) => {
                    // console.log(ref.data);
                    if (ref.data.error === 0) {
                        this.redirect( ref.data.orderId );
                    } else {
                        if (ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997) {
                            this.props.logOut();
                        } else {
                            this.setState({
                                btnSubmit: false,
                                errorForm: true,
                                messageErrorForm: ref.data.message,
                                loadPage: false,
                                isLoading: false,
                            })
                        }
                    }
                    // console.log(this.state.perPage);
                })
                .catch( (error) => {
                    console.log(error);
                    this.setState({
                        btnSubmit: false,
                        loadPage: false,
                        isLoading: false,
                        errorForm: true,
                        messageErrorForm: 'Tạo đơn đặt hàng thất bại',
                    })
                })
        }
    }

    validate = () => {
        if ( !this.state.product.id ) {
            this.setState({
                btnSubmit: false,
                errorForm: 1,
                messageErrorForm: 'Sản phẩm không tồn tại'
            })
            return false;
        }
        else if ( !this.state.billingCycle.length ) {
            this.setState({
                btnSubmit: false,
                errorForm: 1,
                messageErrorForm: 'Thời gian thuê không tồn tại'
            })
            return false;
        }
        else if ( typeof this.state.configBilling[ this.state.billingCycle ] === 'undefined' ) {
            this.setState({
                btnSubmit: false,
                errorForm: 1,
                messageErrorForm: 'Thời gian thuê không có trong dữ liệu'
            })
            return false;
        }
        else if ( this.state.qtt < 1 || this.state.qtt > 50 ) {
            this.setState({
                btnSubmit: false,
                errorForm: 1,
                messageErrorForm: 'Số lượng không được nhỏ hơn 1 hoặc lớn hơn 50'
            })
            return false;
        }
        else if ( !this.state.domain.length ) {
            this.setState({
                btnSubmit: false,
                errorForm: 1,
                messageErrorForm: 'Domain không được để trống'
            })
            return false;
        }
        else if ( this.state.domain.length < 5 || this.state.domain.length > 100 ) {
            this.setState({
                btnSubmit: false,
                errorForm: 1,
                messageErrorForm: 'Số ký tự của Domain không được nhỏ hơn 5 ký tự hoặc lớn hơn 100 ký tự'
            })
            return false;
        }
        return true;
    }

    redirect = (orderId) => {
        this.props.notification({
            isNotification: true,
            textNotification: 'Tạo đơn hàng tạo mới Hosting thành công'
        });
        this.props.shouldRedirect(orderId);
    }

    render() {
        return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary"/>
                        </div>
                    ) : (
                        <>
                            <BreadcrumbCustomer title={"Đặt hàng Cloud Hosting"} page={"Cloud Hosting"} icon={<FaDatabase className="breadcrumb-icon"/>}/>
                            {
                                this.state.error ? (
                                    <Alert color="danger">
                                        <div className='text-center'>
                                            { this.state.messageError }
                                        </div>
                                    </Alert>
                                ) : (
                                    <Card>
                                        <CardBody>
                                            <Row>
                                                {
                                                    this.state.errorForm ? (
                                                        <div className="col-12 col-lg-12">
                                                            <Alert color="danger">
                                                                { this.state.messageErrorForm }
                                                            </Alert>
                                                        </div>
                                                    ) : (
                                                        <></>
                                                    )
                                                }
                                                <div className="col-12 col-lg-7">
                                                    <div className="product-info rounded">
                                                        <p className="product-title">
                                                            { this.state.product.name }
                                                        </p>
                                                        <p className="config-product">
                                                            {
                                                                this.loadConfig()
                                                            }
                                                        </p>
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="domain">Domain</label>
                                                        <input type="text" className="form-control"
                                                               name="domain" id="domain" value={ this.state.domain }
                                                               onChange={ this.changeInput }
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <div>
                                                            <b className="payin-note">Lưu ý: </b>Quý khách chỉ ghi tên
                                                            Domain, không cần ghi đầy đủ tiền tố http:// hoặc
                                                            https://.
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-lg-5">
                                                    {
                                                        this.state.listBillingCycle.length ? (
                                                            <div className="form-group">
                                                                <label htmlFor="billingCycle">Thời gian thuê</label>
                                                                <select name="billingCycle" className="form-control" id="billingCycle"
                                                                        defaultValue={ this.state.billingCycle } onChange={ this.changeInput }
                                                                >
                                                                    {
                                                                        this.state.listBillingCycle.map( (billingCycle,key) => (
                                                                            <option value={ billingCycle.value } key={key}>{ billingCycle.text_pricing }</option>
                                                                        ))
                                                                    }
                                                                </select>
                                                            </div>
                                                        ) : (
                                                            <></>
                                                        )
                                                    }
                                                    <div className="detail-order">
                                                        <div className="title-detail-order">
                                                            Tóm tắt đơn hàng
                                                        </div>
                                                        <div className="order-summary">
                                                            <div className="order-summary-product">
                                                                <div className="item">
                                                                    <div className="itemtitle">
                                                                        { this.state.product.name }
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="col col-md-6 item_billing">
                                                                            { this.state.configBilling[ this.state.billingCycle ] }
                                                                        </div>
                                                                        <div className="col col-md-6 item_pricing text-right">
                                                                            { this.addCommas( this.state.product.pricingProduct ) } ₫
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="order-summary-subtotal">
                                                                <div className="row">
                                                                    <div className="col-md-3">Chi phí</div>
                                                                    <div className="col-md-9 text-right">
                                                                        { this.addCommas( this.state.product.sub_total ) } ₫
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="order-summary-qtt">
                                                                <div className="row">
                                                                    <div className="col-md-3">Số lượng</div>
                                                                    <div className="col-md-9 text-right">{ this.state.qtt }</div>
                                                                </div>
                                                            </div>
                                                            <div className="order-summary-total">
                                                                <div className="row">
                                                                    <div className="col-md-4">Tổng cộng</div>
                                                                    <div className="col-md-8 text-right">{ this.addCommas( this.state.product.sub_total * this.state.qtt ) } ₫</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="button_submit text-center">
                                                            <button type="button" className="btn btn-block btn-primary"
                                                                    disabled={ this.state.btnSubmit }
                                                                    onClick={ () => this.submit() }
                                                            >
                                                                Đặt hàng
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                )
                            }
                        </>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'CustomerOrderHosting' }))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(OrderHostingComponent);